<template>
  <div>
    <!-- Панель управления -->
    <div class="control-panel">
      <div class="container-control">
        <h3>Контейнер 1</h3>
        
        <label>Содержимое:</label>
        <select v-model="container1.content">
          <option v-for="content in contents" :key="'cont1-'+content.name" :value="content">
            {{ content.name }}
          </option>
        </select>
        
        <label>Начальная температура: {{ container1.initialTemp }}K</label>
        <input type="number" v-model.number="container1.initialTemp" min="0" max="1000">
        
        <label>Количество молекул: {{ container1.moleculeCount }}</label>
        <input type="number" v-model.number="container1.moleculeCount" min="1" max="100">
        
        <button @click="addMolecule(1)">Добавить 1 молекулу</button>
      </div>
      
      <div class="container-control">
        <h3>Контейнер 2</h3>
        
        <label>Содержимое:</label>
        <select v-model="container2.content">
          <option v-for="content in contents" :key="'cont2-'+content.name" :value="content">
            {{ content.name }}
          </option>
        </select>
        
        <label>Начальная температура: {{ container2.initialTemp }}K</label>
        <input type="number" v-model.number="container2.initialTemp" min="0" max="1000">
        
        <label>Количество молекул: {{ container2.moleculeCount }}</label>
        <input type="number" v-model.number="container2.moleculeCount" min="1" max="100">
        
        <button @click="addMolecule(2)">Добавить 1 молекулу</button>
      </div>
      
      <div class="stats">
        <h3>Управление</h3>
        <button @click="startSimulation" class="start-button">Запустить</button>
        <button @click="togglePause" class="pause-button">
          {{ isPaused ? 'Продолжить' : 'Пауза' }}
        </button>
        <button @click="resetSimulation" class="reset-button">Сбросить</button>
        
        <h3>Статистика</h3>
        <p>Контейнер 1: {{ container1.molecules.length }} молекул</p>
        <p>Давление: {{ calculatePressure(1).toFixed(2) }} атм</p>
        <p>Температура: {{ container1.temperature.toFixed(1) }}K</p>
        
        <p>Контейнер 2: {{ container2.molecules.length }} молекул</p>
        <p>Давление: {{ calculatePressure(2).toFixed(2) }} атм</p>
        <p>Температура: {{ container2.temperature.toFixed(1) }}K</p>
        
        <p>Тепловой поток: {{ heatFlow.toFixed(2) }} J/s</p>
      </div>
    </div>
    
    <!-- Визуализация -->
    <div class="simulation-container">
      <div class="container" ref="container1" :style="{backgroundColor: getContainerColor(1)}">
        <div 
          v-for="(molecule, index) in container1.molecules" 
          :key="'1-'+index"
          class="molecule"
          :style="{
            left: `${molecule.x}px`,
            top: `${molecule.y}px`,
            width: `${molecule.size}px`,
            height: `${molecule.size}px`,
            backgroundColor: getMoleculeColor(molecule.energy)
          }"
        ></div>
      </div>
      
      <div class="wall" :style="{backgroundColor: wallColor}"></div>
      
      <div class="container" ref="container2" :style="{backgroundColor: getContainerColor(2)}">
        <div 
          v-for="(molecule, index) in container2.molecules" 
          :key="'2-'+index"
          class="molecule"
          :style="{
            left: `${molecule.x}px`,
            top: `${molecule.y}px`,
            width: `${molecule.size}px`,
            height: `${molecule.size}px`,
            backgroundColor: getMoleculeColor(molecule.energy)
          }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      container1: {
        molecules: [],
        temperature: 0,
        initialTemp: 300,
        moleculeCount: 20,
        width: 0,
        height: 0,
        wallMaterial: {name: "Медь", conductivity: 0.92, color: "#b87333"},
        content: {name: "Гелий", mass: 4, color: "#ffcc00"}
      },
      container2: {
        molecules: [],
        temperature: 0,
        initialTemp: 200,
        moleculeCount: 20,
        width: 0,
        height: 0,
        wallMaterial: {name: "Алюминий", conductivity: 0.5, color: "#cccccc"},
        content: {name: "Азот", mass: 28, color: "#00ccff"}
      },
      materials: [
        {name: "Медь", conductivity: 0.92, color: "#b87333"},
        {name: "Алюминий", conductivity: 0.5, color: "#cccccc"},
        {name: "Сталь", conductivity: 0.15, color: "#666666"},
        {name: "Стекло", conductivity: 0.03, color: "#99ccff"},
        {name: "Дерево", conductivity: 0.01, color: "#8b4513"}
      ],
      contents: [
        {name: "Гелий", mass: 4, color: "#ffcc00"},
        {name: "Неон", mass: 20, color: "#ff9900"},
        {name: "Аргон", mass: 40, color: "#ff6600"},
        {name: "Азот", mass: 28, color: "#00ccff"},
        {name: "Кислород", mass: 32, color: "#0066ff"}
      ],
      heatFlow: 0,
      wallColor: "#888888",
      lastTime: 0,
      animationId: null,
      isRunning: false,
      isPaused: false
    }
  },
  methods: {
    initContainers() {
      this.container1.width = this.$refs.container1.clientWidth;
      this.container1.height = this.$refs.container1.clientHeight;
      this.container2.width = this.$refs.container2.clientWidth;
      this.container2.height = this.$refs.container2.clientHeight;
    },
    
    startSimulation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
      }
      
      // Очищаем контейнеры
      this.container1.molecules = [];
      this.container2.molecules = [];
      
      // Устанавливаем начальную температуру
      this.container1.temperature = this.container1.initialTemp;
      this.container2.temperature = this.container2.initialTemp;
      
      // Инициализируем молекулы в соответствии с заданным количеством
      this.initializeMolecules(1, this.container1.moleculeCount);
      this.initializeMolecules(2, this.container2.moleculeCount);
      
      this.isRunning = true;
      this.isPaused = false;
      this.lastTime = 0;
      this.simulate();
    },
    
    togglePause() {
      this.isPaused = !this.isPaused;
      if (!this.isPaused && this.isRunning) {
        this.lastTime = 0;
        this.simulate();
      }
    },
    
    resetSimulation() {
      if (this.animationId) {
        cancelAnimationFrame(this.animationId);
        this.animationId = null;
      }
      this.isRunning = false;
      this.isPaused = false;
      this.container1.molecules = [];
      this.container2.molecules = [];
      this.heatFlow = 0;
    },
    
    initializeMolecules(containerNum, count) {      
      for (let i = 0; i < count; i++) {
        this.addMolecule(containerNum);
      }
    },
    
    addMolecule(containerNum) {
      const container = containerNum === 1 ? this.container1 : this.container2;
      const size = 6 + Math.random() * 4;
      const speed = Math.sqrt(container.temperature) / (10 + container.content.mass / 10);
      const angle = Math.random() * Math.PI * 2;
      
      container.molecules.push({
        x: Math.random() * (container.width - size),
        y: Math.random() * (container.height - size),
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        size: size,
        mass: container.content.mass * (size / 10),
        energy: container.temperature * 0.1,
        color: container.content.color
      });
    },
    
    getMoleculeColor(energy) {
      const intensity = Math.min(255, Math.max(0, energy * 5));
      return `rgb(${intensity}, ${intensity / 2}, ${255 - intensity})`;
    },
    
    getContainerColor(containerNum) {
      const container = containerNum === 1 ? this.container1 : this.container2;
      const temp = container.temperature;
      const intensity = Math.min(200, Math.max(50, temp / 1000 * 200));
      return `rgba(${intensity}, ${intensity}, 255, 0.1)`;
    },
    
    calculatePressure(containerNum) {
      const container = containerNum === 1 ? this.container1 : this.container2;
      const n = container.molecules.length;
      const V = container.width * container.height / 10000;
      const R = 0.0821;
      const T = container.temperature;
      
      return (n * R * T) / V;
    },
    
    updateWallColor() {
      const cond1 = this.container1.wallMaterial.conductivity;
      const cond2 = this.container2.wallMaterial.conductivity;
      const avgCond = (cond1 + cond2) / 2;
      const intensity = Math.floor(avgCond * 255);
      this.wallColor = `rgb(${intensity}, ${intensity}, ${intensity})`;
    },
    
    simulate(timestamp) {
      if (this.isPaused) return;
      
      if (!this.lastTime) this.lastTime = timestamp;
      const deltaTime = timestamp - this.lastTime;
      this.lastTime = timestamp;
      
      this.updateContainerTemperatures();
      this.calculateHeatFlow();
      this.updateMolecules(1, deltaTime);
      this.updateMolecules(2, deltaTime);
      this.updateWallColor();
      
      this.animationId = requestAnimationFrame(this.simulate);
    },
    
    updateContainerTemperatures() {
      const avgEnergy1 = this.container1.molecules.reduce((sum, mol) => sum + mol.energy, 0) / 
                        (this.container1.molecules.length || 1);
      this.container1.temperature = avgEnergy1 * 10;
      
      const avgEnergy2 = this.container2.molecules.reduce((sum, mol) => sum + mol.energy, 0) / 
                        (this.container2.molecules.length || 1);
      this.container2.temperature = avgEnergy2 * 10;
    },
    
    calculateHeatFlow() {
      const deltaT = this.container1.temperature - this.container2.temperature;
      const cond1 = this.container1.wallMaterial.conductivity;
      const cond2 = this.container2.wallMaterial.conductivity;
      const effectiveCond = (cond1 + cond2) / 2;
      
      this.heatFlow = deltaT * effectiveCond * 0.1;
      
      const energyTransfer = this.heatFlow * 0.01;
      
      if (this.container1.molecules.length > 0 && this.container2.molecules.length > 0) {
        const mol1 = this.container1.molecules[
          Math.floor(Math.random() * this.container1.molecules.length)
        ];
        const mol2 = this.container2.molecules[
          Math.floor(Math.random() * this.container2.molecules.length)
        ];
        
        if (energyTransfer > 0) {
          mol1.energy -= energyTransfer / mol1.mass;
          mol2.energy += energyTransfer / mol2.mass;
        } else {
          mol1.energy += -energyTransfer / mol1.mass;
          mol2.energy -= -energyTransfer / mol2.mass;
        }
      }
    },
    
    updateMolecules(containerNum, deltaTime) {
      const container = containerNum === 1 ? this.container1 : this.container2;
      
      container.molecules.forEach(mol => {
        mol.x += mol.vx * (deltaTime / 16);
        mol.y += mol.vy * (deltaTime / 16);
        
        // Столкновения со стенками
        if (mol.x <= 0 || mol.x >= container.width - mol.size) {
          mol.vx *= -1;
          
          // Теплообмен при ударе о разделяющую стенку
          if ((containerNum === 1 && mol.x >= container.width - mol.size) || 
              (containerNum === 2 && mol.x <= 0)) {
            const wallCond = container.wallMaterial.conductivity;
            
            // Реалистичный теплообмен через стенку
            const otherContainer = containerNum === 1 ? this.container2 : this.container1;
            if (otherContainer.molecules.length > 0) {
              const otherMol = otherContainer.molecules[
                Math.floor(Math.random() * otherContainer.molecules.length)
              ];
              
              // Температурный градиент
              const tempGradient = (mol.energy - otherMol.energy) * 0.1;
              
              // Эффективность теплообмена зависит от теплопроводности стенки
              const heatExchange = tempGradient * wallCond * 0.5;
              
              mol.energy -= heatExchange / mol.mass;
              otherMol.energy += heatExchange / otherMol.mass;
            }
            
            // Изменение скорости в зависимости от потери энергии
            const speed = Math.sqrt(mol.energy * 2);
            const angle = Math.atan2(mol.vy, mol.vx);
            mol.vx = Math.cos(angle) * speed;
            mol.vy = Math.sin(angle) * speed;
          }
        }
        
        if (mol.y <= 0 || mol.y >= container.height - mol.size) {
          mol.vy *= -1;
        }
        
        // Столкновения между молекулами
        for (let other of container.molecules) {
          if (other !== mol) {
            const dx = mol.x - other.x;
            const dy = mol.y - other.y;
            const distance = Math.sqrt(dx * dx + dy * dy);
            const minDistance = (mol.size + other.size) / 2;
            
            if (distance < minDistance) {
              // Упругое столкновение с сохранением импульса и энергии
              const angle = Math.atan2(dy, dx);
              const speed1 = Math.sqrt(mol.vx * mol.vx + mol.vy * mol.vy);
              const speed2 = Math.sqrt(other.vx * other.vx + other.vy * other.vy);
              const direction1 = Math.atan2(mol.vy, mol.vx);
              const direction2 = Math.atan2(other.vy, other.vx);
              
              const velocityX1 = speed1 * Math.cos(direction1 - angle);
              const velocityY1 = speed1 * Math.sin(direction1 - angle);
              const velocityX2 = speed2 * Math.cos(direction2 - angle);
              const velocityY2 = speed2 * Math.sin(direction2 - angle);
              
              const finalVelocityX1 = ((mol.mass - other.mass) * velocityX1 + 2 * other.mass * velocityX2) / (mol.mass + other.mass);
              const finalVelocityX2 = ((other.mass - mol.mass) * velocityX2 + 2 * mol.mass * velocityX1) / (mol.mass + other.mass);
              
              mol.vx = Math.cos(angle) * finalVelocityX1 + Math.cos(angle + Math.PI/2) * velocityY1;
              mol.vy = Math.sin(angle) * finalVelocityX1 + Math.sin(angle + Math.PI/2) * velocityY1;
              other.vx = Math.cos(angle) * finalVelocityX2 + Math.cos(angle + Math.PI/2) * velocityY2;
              other.vy = Math.sin(angle) * finalVelocityX2 + Math.sin(angle + Math.PI/2) * velocityY2;
              
              // Частичный обмен теплом при столкновении
              const deltaEnergy = (mol.energy - other.energy) * 0.05;
              mol.energy -= deltaEnergy;
              other.energy += deltaEnergy;
            }
          }
        }
      });
    }
  },
  
  mounted() {
    this.initContainers();
  },
  
  beforeUnmount() {
    if (this.animationId) {
      cancelAnimationFrame(this.animationId);
    }
  }
}
</script>

<style>
.control-panel {
  display: flex;
  justify-content: space-around;
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f0f0f0;
  border-radius: 8px;
}

.container-control {
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  width: 30%;
}

.stats {
  padding: 10px;
  background-color: white;
  border-radius: 5px;
  width: 30%;
}

.simulation-container {
  display: flex;
  height: 500px;
  margin-bottom: 20px;
}

.container {
  position: relative;
  width: 50%;
  height: 100%;
  border: 2px solid #333;
  overflow: hidden;
}

.wall {
  width: 2px;
  height: 100%;
  background-color: #888;
}

.molecule {
  position: absolute;
  border-radius: 50%;
  transition: transform 0.1s;
}

button {
  margin-top: 10px;
  padding: 8px 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  font-weight: bold;
}

.start-button {
  background-color: #4CAF50;
  color: white;
}

.start-button:hover {
  background-color: #45a049;
}

.pause-button {
  background-color: #FFC107;
  color: black;
}

.pause-button:hover {
  background-color: #FFA000;
}

.reset-button {
  background-color: #f44336;
  color: white;
}

.reset-button:hover {
  background-color: #d32f2f;
}

select, input[type="number"] {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-sizing: border-box;
}

label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

h3 {
  margin-top: 0;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 5px;
}
</style>